// extracted by mini-css-extract-plugin
export default {"container":"VeilleManager_container__nwQVZ"};